import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { TagService } from "../../../../../../service/tag.service";
import { ClientService } from "../../../../../../service/client.service";
import { DataService } from '../../../../../../service/data.service';
import { RoService } from "../../../../../../service/ro.service"
import { SnackbarService } from "../../../../../../service/snackbar.service";
import { Router } from '@angular/router';

@Component({
  selector: 'app-card-dialog',
  templateUrl: './card-dialog.component.html',
  styleUrls: ['./card-dialog.component.scss']
})
export class CardDialogComponent implements OnInit{
  constructor(
    public dialogRef: MatDialogRef<CardDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private tagService: TagService,
    private clientService: ClientService,
    private dataService: DataService,
    private _router: Router,
    private roService: RoService,
    private snackbar: SnackbarService,
  ) {}

  minDate: Date = new Date();

  tagList = []
  tagsFormControl = new FormControl([])
  priorityList = ['low', 'medium', 'high', 'critical']
  priorityLabels = {
    'low': 'Baixa',
    'medium': 'Média',
    'high': 'Alta',
    'critical': 'Crítica'
  }

  priorityFormControl = new FormControl()
  dueDateFormControl = new FormControl()
  client = null

  ngOnInit() {
    this.getData()
  }

  async getData() {
    let tags = await this.tagService.getAll()
    this.tagList = tags.map(tag => tag.description)
    const selectedTags = this.data.card.tags.map(tag => tag.description)
    this.tagsFormControl.setValue(selectedTags)
    this.priorityFormControl.setValue(this.data.card.priority)
    this.dueDateFormControl.setValue(this.data.card.dueDate)
    this.client = await this.clientService.get(this.data.card.client.id);
  }

  goToDetail(id) {
    const url = ['/company', this.dataService.company.id, 'os', 'detail', id]
    this.dialogRef.close()
    this._router.navigate(url)
  }

  async editInfoCard(card) {
    const tags = this.tagsFormControl.value.map(kanbanTag => { return { description: kanbanTag } })
    const priority = PRIORITY[this.priorityFormControl.value as string] || 0;
    const dueDate = this.dueDateFormControl.value as string

    try {
      await this.roService.update(card.id, [
        { field: 'tags', newValue: tags },
        { field: 'priority', newValue: priority },
        { field: 'deliveryForecast', newValue: dueDate }
      ], card);
      this.snackbar.success(`RO.UPDATED`, {code: card.osCode});
      this.dialogRef.close('updated');
    } catch (error) {
      console.error(error)
      this.snackbar.error(`RO.NOT_UPDATED`, {code: card.osCode}, error);
      this.dialogRef.close()
    }

  }

}

export enum PRIORITY {
  '' = 0,
  'low' = 1,
  'medium' = 2,
  'high' = 3,
  'critical' = 4
};
